// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__bxin6","selected":"Chip_selected__2A0WC"};